

























































































// command to build web component : npx vue-cli-service build --mode production --target wc --name the-upload-document src/views/kyc-form/section/TheUploadDocument.vue
import { Component, Vue, Prop } from 'vue-property-decorator'
import { isEmpty, isUndefined, isNull } from 'lodash/fp'
import dayjs from 'dayjs'
import API from '@core/services/API'
import { inject } from 'inversify-props'
import { UIService } from '@core/services/UIService'
import { SharedVariable } from '@core/model/SharedVariable'
import AppDialog from '@core/components/AppDialog.vue'

interface Sort {
  prop: string;
  order: 'ascending' | 'descending';
}

@Component({
  components: {
    AppDialog
  }
})
export default class TheUploadDocument extends Vue {
  @inject()
  private $api: API

  @inject()
  private sharedVariable: SharedVariable

  uiService: UIService

  @Prop() documentTypeOption
  @Prop() readonly kycFormOid
  private showAddNewDocumentDialog = false
  private selectedDocumentType = ''
  private newDocument
  private uploadedPDFList = []
  private parsedDocumentTypeOption = []

  private sortBy: Sort = {
    prop: 'fileName',
    order: 'descending'
  }

  sort (prop) {
    this.sortBy.prop = prop
    this.sortBy.order = this.sortBy.order === 'descending' ? 'ascending' : 'descending'
    this.uploadedPDFList = this.sortedData(this.uploadedPDFList)
  }

  sortedData (array) {
    if (!array) {
      return []
    }
    const data = array.sort((a, b) => {
      if (this.sortBy.order === 'ascending') {
        if (a[this.sortBy.prop] > b[this.sortBy.prop]) { return 1 }
        if (a[this.sortBy.prop] < b[this.sortBy.prop]) { return -1 }
      } else {
        if (a[this.sortBy.prop] > b[this.sortBy.prop]) { return -1 }
        if (a[this.sortBy.prop] < b[this.sortBy.prop]) { return 1 }
      }
      return 0
    })
    return data
  }

  handleFileUpload (fileList) {
    // handle file changes
    if (!fileList.length) return
    this.newDocument = fileList[0]
  }

  async resetField () {
    this.showAddNewDocumentDialog = false
    this.selectedDocumentType = ''
    const inputFile = this.$refs.inputFile as HTMLInputElement
    if (inputFile?.value) inputFile.value = ''
    await this.loadDataBase()
  }

  async download (document) {
    window.open(`/live/api/kyc-doc-upload/${this.kycFormOid}/${document.pdfOid}`, '_blank')
  }

  async deleteDoc (document) {
    const data = await this.$api.uploadDoc.delete(this.kycFormOid, document.pdfOid)

    if (data.error) {
      await this.uiService.alert.show({
        type: 'error',
        message: data.error
      })
    } else if (data.success) {
      await this.resetField()
    } else {
      await this.uiService.alert.show({
        type: 'error',
        message: 'Fail to delete, something wrong'
      })
    }
  }

  async loadDataBase () {
    const data = await this.$api.uploadDoc.list({ kycFormOid: this.kycFormOid })

    if (data.error) {
      await this.uiService.alert.show({
        type: 'error',
        message: data.error
      })
      return
    }
    this.uploadedPDFList = this.sortedData(data)
    this.$emit('update', this.uploadedPDFList)
  }

  async uploadDocument () {
    if (isEmpty(this.selectedDocumentType)) {
      await this.uiService.alert.show({
        type: 'warning',
        message: 'Please select Document Type'
      })
      return
    }

    if (!this.newDocument) {
      await this.uiService.alert.show({
        type: 'warning',
        message: 'Please choose file'
      })
      return
    }

    const formData = new FormData()
    formData.append('kycformOid', this.kycFormOid)
    formData.append('fileName', this.newDocument.name)
    formData.append('documentType', this.selectedDocumentType)
    formData.append('file', this.newDocument, this.newDocument.name)

    const data = await this.$api.uploadDoc.upload(formData)

    if (data.error) {
      await this.uiService.alert.show({
        type: 'error',
        message: data.error
      })
    } else if (data.success) {
      await this.uiService.alert.show({
        type: 'success',
        message: 'Upload Success'
      })
      await this.resetField()
    } else {
      await this.uiService.alert.show({
        type: 'error',
        message: 'Upload fail, something wrong'
      })
      this.showAddNewDocumentDialog = false
    }
  }

  async mounted () {
    if (this.documentTypeOption && this.hasJsonStructure(this.documentTypeOption)) {
      this.parsedDocumentTypeOption = JSON.parse(this.documentTypeOption)
    } else {
      this.parsedDocumentTypeOption = this.documentTypeOption
    }

    this.uiService = this.sharedVariable.uiService

    await this.loadDataBase()
  }

  convertTimestamptoDateString (timeStamp) {
    return dayjs(new Date(Number(timeStamp))).format('DD/MM/YYYY')
  }

  getActiveClass (prop, order) {
    return this.sortBy.prop === prop &&
      this.sortBy.order === order ? 'active' : null
  }

  formatFileSize (bytes = 0, si = true, dp = 0) {
    const thresh = si ? 1000 : 1024

    if (isUndefined(bytes) || isNull(bytes)) return '0B'
    if (Math.abs(bytes) < thresh) {
      return bytes + ' B'
    }

    const units = si
      ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
    let u = -1
    const r = 10 ** dp

    do {
      bytes /= thresh
      ++u
    } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1)

    return bytes.toFixed(dp) + '' + units[u]
  }

  hasJsonStructure (str) {
    if (typeof str !== 'string') return false
    try {
      const result = JSON.parse(str)
      const type = Object.prototype.toString.call(result)
      return type === '[object Object]' || type === '[object Array]'
    } catch (err) {
      return false
    }
  }
}
